import React from 'react';
import styles from './choice.module.css';

const PERCENT = 100;

/** A range slider in the panel's accent, its track filled up to the value; reports numbers between `min` and `max`. */
export const Slider = ({ label, value, min, max, step = 1, onChange }) => (
    <input
        type="range"
        className={styles.slider}
        aria-label={label}
        min={min}
        max={max}
        step={step}
        value={value}
        style={{ '--fill': `${((value - min) / (max - min)) * PERCENT}%` }}
        onChange={(event) => onChange(Number(event.target.value))}
    />
);
